<template>
    <div class="box-second">
        <p class="title-crumb">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>设备检查</el-breadcrumb-item>
                <el-breadcrumb-item>风险检查</el-breadcrumb-item>
                <el-breadcrumb-item>历史记录</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
            <div class="build-bar" style="padding:0 20px;">
                <el-page-header @back="goBack" content=""></el-page-header>
                <!-- <el-date-picker
                    v-model="time"
                    align="right"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                    @change="timeChange"
                    :picker-options="pickerOptions">
                </el-date-picker> -->
                <!-- <el-button type="primary" icon="el-icon-search" @click="doFilter">查询</el-button> -->
                <!-- <el-button type="primary" @click="addRow()">添加设备</el-button> -->
                <!-- <el-button type="success" @click="handleEdit">参数配置</el-button> -->
            </div>
            <div class="main-table">
                <el-table :data="tableDataEnd" height="100%" style="width: 100%" :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column label="序号" type="index" width="100"></el-table-column>
                    <el-table-column label="风险场所名称">
                        <template slot-scope="scope">
                            <span class="color5" >{{scope.row.riskPlace.workPlace}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="时间">
                        <template slot-scope="scope">
                            <span>{{ scope.row.riskPlace.createDate }}</span>
                        </template>
                    </el-table-column>
                      <el-table-column label="签名人">
                        <template slot-scope="scope">
                            <span>{{ scope.row.user.name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="签名照片">
                     <template slot-scope="scope">
                    <el-image v-if="scope.row.signaturePhoto" style="width: 50px; height: 50px" :src="http+scope.row.signaturePhoto" :preview-src-list="scope.row.imageList"></el-image>
                    <span v-else>暂无图片</span>
                  </template>
       
                    </el-table-column>
              
                    <!-- <el-table-column label="操作" >
                        <template slot-scope="scope">
                            <el-button size="mini" v-if="isMenuExit('pro:elebox:edit')" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                            <el-button size="mini" v-if="isMenuExit('pro:elebox:del')" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                            <el-button size="mini" @click="erCode(scope.$index, scope.row)">二维码</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
                <!-- 表单列表 -->
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[3, 5, 10]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalItems"
                ></el-pagination>
            </div>
        </div>
        <!-- 新增窗口 -->
        <el-dialog
            :title="dialogTitle"
            :visible.sync="addVis"
            center
            :append-to-body="true"
            :lock-scroll="false"
            class="add-form"
            width="30%"
        >
            <el-form
            :model="addForm"
            ref="addForm"
            label-width="100px"
            :label-position="labelPosition"
            >
                <el-form-item label="位置描述：">
                    <el-input v-model="addForm.location" placeholder="请输入位置描述" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="序列号：" prop="sn">
                    <el-input v-model="addForm.sn" placeholder="请输入序列号" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="参数：">
                    <el-input v-model="addForm.parameter" placeholder="请输入参数" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="备注：">
                    <el-input v-model="addForm.remarks" placeholder="备注" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <!-- <div slot="footer" class="dialog-footer">
            <el-button @click="addVis = false">取 消</el-button>
            <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
            </div> -->
        </el-dialog>
        <!-- 二维码弹出框 -->
        <!-- <el-dialog
            :title="codeTit"
            :visible.sync="codeVis"
            center
            :append-to-body="true"
            :lock-scroll="false"
            width="30%"
            style="height:100%;"
        >
            <div class="erCode">
                <vue-qr :text="codeUrl" :size="200"></vue-qr>
            </div>
        </el-dialog> -->
    </div>
</template>

<script>
import base from '../../../untils/base'
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
// import vueQr from 'vue-qr'
export default {
    // components: {
    //         vueQr
    // },
    data(){
        return{
            tableSn:'',
            tableDataEnd:[],
            currentPage:1,
            pageSize:10,
            totalItems:0,
            groupId:'',
            dataText:'数据加载中...',
            addVis:false,
            dialogTitle:'',
            labelPosition:'right',
            addForm:{
                id:'',
                projectId:'',
                sn:'',
                parameter:'',
                location:'',
                remarks:''
            },
            // rules:{
            //     sn: [{ required: true, message: '请输入设备序列号', trigger: 'blur' }]
            // },
            // //二维码
            // codeVis:false,
            // codeUrl:'',
            // codeTit:'',
            pickerOptions:{
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                    picker.$emit('pick', new Date());
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24);
                    picker.$emit('pick', date);
                    }
                }, {
                    text: '一周前',
                    onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', date);
                    }
                }]
            },
            time:'',
            id:'',
            http:base.httpCtx
        }
    },
    mounted(){
        this.id = this.$route.params.id
        this.groupId = util.session.get('groupId')
        this.addForm.projectId = this.groupId
        this.getData()
    },
    methods:{
        getData(){
            var that = this
            myHttp.getRiskPlaceSignaturePage({
                // userId: util.session.get('user').id,
                // idcard :util.session.get('user').idcard,
                projectId:this.groupId,
                riskPlaceId:this.id,
                pageNum:this.currentPage,
                pageSize:this.pageSize
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.riskPlaceSignature.list||[]
                    for(var i=0;i<list.length;i++){
                        list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
                        list[i].imageList =list[i].signaturePhoto == ''? []: [that.http+list[i].signaturePhoto]
                    }
                    that.tableDataEnd = list
                    that.totalItems = resp.data.data.riskPlaceSignature.total
                    if (that.tableDataEnd.length == 0) {
                        that.dataText = '暂无数据'
                    }
                }else{
                    that.dataText = '暂无数据'
                }
            })
        },
        handleSizeChange(val) {
          this.pageSize = val
          this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
          console.log(`当前页: ${val}`)
          this.currentPage = val
          this.getData()
        },
        // 监控当前页码
        currentChangePage() {
          this.getData()
        },
        //监听时间变化
        timeChange(e){
            this.currentPage = 1
            this.getData()
        },

        //添加
        // addRow(){
        //     this.addVis = true
        //     this.addForm.id = ''
        //     this.addForm.sn = ''
        //     this.addForm.parameter = ''
        //     this.addForm.location = ''
        //     this.addForm.remarks = ''
        //     this.dialogTitle = '添加设备'
        // },
        //编辑
        handleEdit(index,row){
            this.addVis = true
            this.addForm.id = row.id
            this.addForm.sn = row.sn
            this.addForm.parameter = row.parameter
            this.addForm.location = row.location
            this.addForm.remarks = row.remarks
            this.dialogTitle = '信息'
        },
        //删除
        handleDelete(index,row){
            var that = this
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                myHttp.delDistribution({
                    id: row.id,
                    updateBy:util.session.get('user').id
                }).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message.success('删除成功')
                        that.getData()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                })
            })
        },

        /**
         * 返回
         */
        goBack(){
            this.$router.go(-1)
        },
        //提交
        // sumbitAddRow(formName){
        //     var that = this
        //     this.$refs[formName].validate(valid => {
        //         if (valid) {
        //             //console.log(that.addForm.id)
        //             if(that.addForm.id==''){
        //                 that.addForm.createBy = util.session.get('user').id
        //                 myHttp.createDistribution(that.addForm).then(
        //                     function(resp) {
        //                         if (resp.data.code == '200') {
        //                             that.$message.success('添加成功')
        //                             that.addVis = false
        //                             that.currentPage = 1
        //                             that.getData()
        //                         } else {
        //                             that.$message.error(resp.data.msg)
        //                         }
        //                     },
        //                     function() {}
        //                 )
        //             }else{
        //                 that.addForm.updateBy = util.session.get('user').id
        //                 myHttp.modDistribution(that.addForm).then(
        //                     function(resp) {
        //                         if (resp.data.code == '200') {
        //                             that.$message.success('修改成功')
        //                             that.addVis = false
        //                             that.getData()
        //                         } else {
        //                             that.$message.error(resp.data.msg)
        //                         }
        //                     },
        //                     function() {}
        //                 )
        //             }
        //         }
        //     })
        // },

        //展示二维码
        // erCode(index,row){
        //     this.codeVis = true
        //     this.codeUrl = '/pages/equipCheck/equipCheck?snId='+row.sn
        //     this.codeTit = row.location
        // },

        /**
         * 判断是否展示
         */
        // isMenuExit(row){
        //     // var flag = util.common.filterBtnMenu(row)
        //     // return flag
        //     return true
        // },

    },
}
</script>

<style scoped>
    .main{
        flex-wrap: wrap;
        align-content: flex-start;
    }
    .main-table{
        width: 100%;
        height: calc( 100% - 11.4vh );
    }
    .build-bar {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 6vh;
        border-bottom: 3px solid #17b2fe;
        background: #fff;
    }

    .build-bar span {
        margin-left: 30px;
        white-space: nowrap;
        display: inline-block;
    }

    .build-bar > .el-input {
        width: 200px;
        font-size: 12px;
    }
    .build-bar > .el-button {
        margin-left: 30px;
        /* background-color: #17b2fe;
        border-color: #17b2fe; */
    }
    .erCode{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
        flex-wrap: wrap;
    }
</style>

<style>
    @import '../../../assets/css/common.css'
</style>